const STYLES = {
  pending: "border-amber-400/40 text-amber-300",
  confirmed: "border-[var(--acid)]/60 text-[var(--acid)]",
  completed: "border-emerald-400/40 text-emerald-300",
  cancelled: "border-red-400/40 text-red-300",
};

export const StatusBadge = ({ status, testid }) => (
  <span data-testid={testid} className={`inline-flex rounded-full border px-3 py-1 font-mono-x text-[11px] uppercase tracking-widest ${STYLES[status] || "border-white/20 text-zinc-300"}`}>
    {status}
  </span>
);

export const STATUSES = ["pending", "confirmed", "completed", "cancelled"];
